import { QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { CACHE_POLICY, shouldRetryQuery } from './cache-policy';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Default tier for hooks that do not declare one. Individual hooks pick a
      // tier from CACHE_POLICY based on what kind of data they hold.
      staleTime: CACHE_POLICY.default.staleTime,
      // Far longer than staleTime on purpose: it is what keeps a revisited
      // screen paintable from cache while it revalidates. The old 10-minute
      // gcTime evicted data a user was likely to come back to, turning an
      // ordinary navigation into a cold load.
      gcTime: CACHE_POLICY.default.gcTime,
      retry: shouldRetryQuery,
      refetchOnWindowFocus: true, // SWR pattern per PRD
    },
    mutations: {
      retry: 0,
      onError: (error: Error) => {
        toast.error(error.message || 'Something went wrong');
      },
    },
  },
});
